import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#ff6663",
        secondary: "#e4b363",
        accent: "#39a0ed",
        error: "#b71c1c",
      },
    },
  },
});
